import { NewsEntryFeature } from '../../../../features/news/types/UnifiedNewsEntry'
import { VersionInfo } from '../../../../types/VersionInfo'

export type GameAnalysisScreenshot = {
  screenshotId: string
  url?: string
  features?: Record<string, number>
  commentId?: string | null
  commentPublished?: boolean
  conceptIds?: string[]
}

// `GET games/{gameId}/analyses`, only the fields the list uses.
export type GameAnalysis = {
  id: string
  ts: number
  gameId: string
  gameVersion?: string | null
  marketId: string
  marketIso: string
  storeId: string
  powerScore?: number | null
  createdAt?: number | null
  createdBy?: string | null
  modifiedAt?: number | null
  modifiedBy?: string | null
  finalizedAt?: number | null
  finalizedBy?: string | null
  commentId?: string | null
  commentPublished?: boolean
  screenshots?: GameAnalysisScreenshot[] | null
}

export type GameVersion = Pick<VersionInfo, 'id' | 'appId' | 'version' | 'versionReleaseDate' | 'releaseNotes' | 'description' | 'market'> & {
  tags?: string[] | null
  overrideTags?: boolean
}

// `GET i/analyses/versions/{gameId}/latest`: the newest manually analyzed version of each market.
export type AnalyzedVersionPerMarket = {
  gameVersion?: string | null
  analysisId?: string | null
  latestAnalysisId?: string | null
  marketName: string
  marketIso: string
}

export type AnalysisListRow = {
  id: string
  ts: number
  gameVersion?: string | null
  // None for a listed version without an analysis.
  analysis?: GameAnalysis
}

export const latestGameVersion = 'latest'

export type CreateAnalysisRequest = { gameId: string; marketId: string; storeId: string }
export type CloneAnalysisRequest = { id: string; gameId: string }
export type CloneAnalysisToMarketRequest = { gameId: string; sourceMarketIso: string; targetMarketIso: string; gameVersion: string }
export type CreateAnalysisForVersionRequest = { version: string; marketId: string; gameId: string }
export type DeleteAnalysisRequest = { id: string; gameId: string; marketIso: string }

export type SaveVersionTagsRequest = { appId: number; version: string; tags: string[]; marketIso: string }

// `GET entries/analysis/{id}` on the feed server.
export type AnalysisNewsEntry = {
  id?: string
  entryData?: { analysisId?: string; features?: NewsEntryFeature[] | null } | null
}
